module.exports = __webpack_public_path__ + "static/media/white-brand-name.a8ae5fcb.svg";